import TranslationData from '@/models/TranslationData';

const translation: TranslationData = {
  search: {
    title: 'Søgning',
  },
  searchResults: {
    showMore: 'vis flere resultater',
    noResults: 'Beklager, vi kunne ikke finde nogen matchende søgeresultater for dit søgeord <b>{storeSearchTerm}</b>',
    noResultsHint: '',
    badges: {
      pfsc: '',
      fsc: '',
      fsc_pfsc: 'FSC® eller PEFC',
      ecofriendly: 'Miljømaterialer',
      overnight: 'Express og Overnight',
      sameday: 'Sameday',
      express: 'Express',
      onlineDesign: 'Online design',
    },
    taglines: {
      home: 'Lær mere',
      text: 'Lær mere',
      themes: 'Lær mere',
      external: 'Lær mere',
      info: 'Lær mere',
      category: 'Lær mere',
      content: 'Lær mere',
      product: 'Konfigurer nu',
    },
    headings: {
      categories: 'Produktkategorier',
      products: 'Produkter',
      external: 'Mere information',
    },
    slider: {
      previousSlide: 'Vis forrige indhold',
      nextSlide: 'Vis næste indhold ',
    },
  },
  searchInput: {
    inputTooShortError: 'Dit søgeudtryk er for kort (min. 2)',
    results: 'Resultater',
    result: 'Resultat',
    youSearchFor: 'Resultater for',
    suggestedTerm: {
      didYouMean: 'Mente du',
      resultsFor: 'Søg i stedet efter',
      didYouMeanPostFix: '?',
      resultsForPostFix: '-resultater',
    },
  },
  toolsBar: {
    buttons: {
      listButtonTooltip: 'Listevisning',
      gridButtonTooltip: 'Flisevisning',
    },
    quickFilter: {
      filterChips: {
        clearAllFilters: 'Ryd alle filtre',
        resetFilters: 'Nulstil til standard',
      },
      buttonsPanel: {
        filterLabel: 'Filtre',
        buttonsTooltipLabel: 'Visning',
        resultLabel: 'Søgeresultater',
      },
      contexts:
        {
          product: 'Produkter',
          content: 'Diverse',
          all: 'all',
          category: 'Produktkategorier',
          external: 'Mere information',
        },
    },
    breadcrumbs: {
      start: 'Start',
      search: 'Søgning',
    },
  },
  sideBar: {
    filter: 'Filter',
    filterOverwrite: {
      category: {
        text: 'Kategorier',
      },
      rootCategory: {
        text: 'Kategorier',
      },
      specialFeatures: {
        text: 'Special Features',
        options: {
          logoFsc: 'Logo FSC',
          logoPfsc: 'Logo PFSC',
          logoFscPfsc: '',
          samedayAvailable: 'Lieferung am selben Tag',
          expressAvailable: 'Expresszustellung',
          overnightAvailable: 'Overnight Lieferung',
          ecoFriendly: 'Nachhaltige Materialen',
          onlineDesign: 'Online design',
          new: 'New',
        },
      },
    },
    more: 'Show more',
    less: 'Show less',
  },
  common: {
    warnings: {
      server401: 'Din session er udløbet, og du skal logge ind igen. Du vil blive videresendt til login med det samme.',
      server403: 'Anmodningen er ikke blevet anvendt, fordi den mangler gyldige autentifikationsoplysninger. Genindlæs venligst siden igen, eller kontakt vores kundeservice.',
      default: 'Der var en fejl på serveren. Genindlæs venligst siden igen, eller kontakt vores kundeservice.',
    },
    errors: {
      server400: 'Anmodningen var misdannet. Please reload the page or contact our customer service.',
      server404: '404 Side ikke fundet. Gå venligst til den foregående side eller kontakt vores kundeservice.',
      server500: 'Der var en fejl på serveren. Genindlæs venligst siden igen, eller kontakt vores kundeservice.',
      server501: 'Der var en fejl på serveren. Genindlæs venligst siden igen, eller kontakt vores kundeservice.',
      server502: 'Der var en fejl på serveren, og du får et ugyldigt svar. Genindlæs venligst siden eller kontakt vores kundeservice.',
      server503: 'Der var en fejl på serveren. Genindlæs venligst siden eller kontakt vores kundeservice.',
      server504: 'Der var en fejl på serveren. Genindlæs venligst siden igen eller kontakt vores kundeservice.',
      default: 'Serveren har et problem med anmodningen. Genindlæs venligst siden igen, eller kontakt vores kundeservice.',
    },
  },
};
export default translation;
